import { AuditLog } from "@lib/types/Monitoring";
import { Descriptions, Tag, Typography } from "antd";
import { FaCheckSquare, FaHashtag, FaUser, FaWifi } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { StyledDescriptionLabel } from "./index.styled";
import { showCountryName } from "@lib/helpers/StringHelper";
import { MdAlternateEmail } from "react-icons/md";
import {
  auditLogActionTypeColor,
  auditLogRequestStatusColor,
} from "@lib/helpers/ColorHelper";
import { TbFileDescription } from "react-icons/tb";
import { PiDevicesBold, PiNetworkBold, PiPathBold } from "react-icons/pi";
import { SiAdobecreativecloud } from "react-icons/si";
import { IoIosPricetags } from "react-icons/io";
import { CgTime } from "react-icons/cg";
import { Link } from "react-router-dom";

type Props<T> = {
  data: T;
};

const LogDetail = <T extends AuditLog>({ data }: Props<T>) => {
  // const { messages } = useIntl();

  return (
    <>
      <Descriptions>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FaUser />
              <FormattedMessage id="common.managerName" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {`${data?.manager?.firstName} ${data?.manager?.lastName}`}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FaHashtag />
              <FormattedMessage id="common.managerId" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text
            copyable={{ text: data?.managerId }}
            ellipsis={{ tooltip: true }}
          >
            {data?.managerId}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <MdAlternateEmail />
              <FormattedMessage id="common.managerEmail" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text
            ellipsis={{ tooltip: true }}
            copyable={{ text: data?.manager?.email }}
          >
            {data?.manager?.email}
          </Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <MdAlternateEmail />
              <FormattedMessage id="common.actionType" />
            </StyledDescriptionLabel>
          }
        >
          <Tag color={auditLogActionTypeColor(data?.actionType)}>
            {data?.actionType}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <TbFileDescription />
              <FormattedMessage id="common.description" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.description}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FaCheckSquare />
              <FormattedMessage id="common.requestStatus" />
            </StyledDescriptionLabel>
          }
        >
          <Tag color={auditLogRequestStatusColor(data?.reqStatus)}>
            {data?.reqStatus}
          </Tag>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <PiPathBold />
              <FormattedMessage id="common.path" />
            </StyledDescriptionLabel>
          }
        >
          <Link to={data?.path} target="_blank">
            <Typography.Text copyable={{ text: data?.path }} ellipsis>
              {data?.path}
            </Typography.Text>
          </Link>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <SiAdobecreativecloud />
              <FormattedMessage id="common.entity" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.entity}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <IoIosPricetags />
              <FormattedMessage id="common.identifier" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.identifier}
          </Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <PiNetworkBold />
              <FormattedMessage id="common.fields" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.fields}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <CgTime />
              <FormattedMessage id="common.createdAt" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.createdAt}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <PiDevicesBold />
              <FormattedMessage id="common.platform" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {data?.extraData?.auditReq?.headers["user-agent"]}
          </Typography.Text>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FaWifi />
              <FormattedMessage id="common.ipAddress" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text
            ellipsis={{ tooltip: true }}
            copyable={{ text: data?.ipAddress }}
          >
            {data?.ipAddress}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <StyledDescriptionLabel>
              <FaWifi />
              <FormattedMessage id="common.country" />
            </StyledDescriptionLabel>
          }
        >
          <Typography.Text ellipsis={{ tooltip: true }}>
            {showCountryName(data?.country)}
          </Typography.Text>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default LogDetail;
